<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      justify-left
      wrap>
      <repayment-detail-info
        :repayment="repayment"
        :bank-claim="bankClaim"/>
      <v-flex md12>
        <h3 class="heading-4">{{ 'krita.repayment.factorings' | translate }}</h3>
        <br >
        <v-card>
          <search-text-field
            :search-phrase="factoringsSearch"
            @search="factoringsSearchRefresh"
          />
          <FactoringsDatagrid
            :factorings="factorings"
            :factorings-loading="factoringsLoading"
            @refreshWithSort="refreshFactoringsWithSort"
          />
          <div class="text-xs-center pt-2">
            <pagination
              :selected-page="factoringsSelectedPage"
              :rows-per-page="factoringsRowsPerPage"
              :row-count="factoringsRowCount"
              @changeDisplayedRowCount="factoringsChangeDisplayedRowCount"
              @clickedPage="changeFactoringsPage"
            />
          </div>
        </v-card>
      </v-flex>
      <v-flex md12>
        <h3 class="heading-4">{{ 'krita.repayment.history' | translate }}</h3>
        <br >
        <v-card>
          <HistoryDatagrid
            :history="history"
            :history-loading="historyLoading"/>
          <div class="text-xs-center pt-2">
            <pagination
              :selected-page="historySelectedPage"
              :rows-per-page="historyRowsPerPage"
              :row-count="historyRowCount"
              @changeDisplayedRowCount="historyChangeDisplayedRowCount"
              @clickedPage="changeHistoryPage"/>
          </div>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import RepaymentDetailInfo from './repaymentDetail/RepaymentDetailInfo'
import FactoringsDatagrid from './repaymentDetail/FactoringsDatagrid'
import HistoryDatagrid from './repaymentDetail/HistoryDatagrid'
import Pagination from './controllers/Pagination'
import SearchTextField from './controllers/SearchTextField';
import EnumIterator from './helper/EnumIterator'

    export default {
        name: "RepaymentDetail",
        components: {RepaymentDetailInfo, FactoringsDatagrid, HistoryDatagrid, Pagination, SearchTextField},
        props: ['id'],
        data ()
        {
            return {
                repayment: {},
                bankClaim: {},

                history: [],
                historyLoading: false,
                historySort: {
                    sort:'desc',
                    sortBy:'status'
                },
                historySelectedPage: 1,
                historyRowsPerPage: '5',
                historyRowCount: '',

                factorings: [],
                factoringsLoading: false,
                factoringsSort: {
                    sort:'desc',
                    sortBy:'modified'
                },
                factoringsSearch: '',
                factoringsSelectedPage: 1,
                factoringsRowsPerPage: '5',
                factoringsRowCount: '',
            }
        },
        mounted ()
            {
                let self = this;

                self.refreshPage();
            },
        methods : {
            //change pages
            changeFactoringsPage (page)
            {
                let self = this;

                self.factoringsSelectedPage = page;
                self.refreshFactorings();
            },
            changeHistoryPage (page)
            {
                let self = this;

                self.historySelectedPage = page;
                self.refreshRepaymentHistoryData();
            },

            factoringsChangeDisplayedRowCount (rowCount)
            {
              let self = this;

              self.factoringsSelectedPage = 1;
              self.factoringsRowsPerPage = isNaN(parseInt(rowCount))? -1 : parseInt(rowCount);
              self.refreshFactorings();
            },
            historyChangeDisplayedRowCount (rowCount)
            {
              let self = this;

              self.historySelectedPage = 1;
              self.historyRowsPerPage = isNaN(parseInt(rowCount))? -1 : parseInt(rowCount);
              self.refreshRepaymentHistoryData();
            },
            //refresh data
            refreshPage ()
            {
                let self = this;

                self.refreshRepaymentDetailData();
                self.refreshRepaymentHistoryData();
            },
            refreshFactoringsWithSort (pagination)
            {
              let self = this;

              self.factoringsSort.sort = pagination.descending ? 'desc' : 'asc';
              self.factoringsSort.sortBy = pagination.sortBy;
              self.refreshFactorings ();
            },
            factoringsSearchRefresh (search)
            {
              let self = this;

              if (search !=='')
              {
                self.factoringsSelectedPage = 1;
              }
              self.factoringsSearch = search;
              self.refreshFactorings();
            },
            refreshFactorings ()
            {
                let self = this;

                if (self.repayment.Status === self.$t('krita.repayment.status.cancelled'))
                {
                  self.refreshRepaymentFactoringsHistoryData();
                }
                else
                {
                  self.refreshRepaymentFactoringsData();
                }
            },
            refreshRepaymentDetailData ()
            {
                let self = this;

                let repaymentFetch = self.$store.dispatch('repayments/getRepaymentDetail', {id:self.id});
                repaymentFetch.then(response =>
                {
                    self.processRepaymentDetailData(response);
                    self.refreshFactorings();
                }, ()=>
                {

                })
            },
            refreshRepaymentFactoringsData()
            {
                let self = this;

                let factoringsFetch = self.$store.dispatch('repayments/getRepaymentsFactorings', {id: self.id, page: self.factoringsSelectedPage, rowsPerPage: self.factoringsRowsPerPage, sort: self.factoringsSort.sort,sortBy: self.factoringsSort.sortBy, search: self.factoringsSearch });
                factoringsFetch.then(response =>
                {
                    self.processRepaymentFactorings(response);
                }, ()=>
                {

                })
            },
            refreshRepaymentFactoringsHistoryData()
            {
                let self = this;

                let factoringsFetch = self.$store.dispatch('repayments/getRepaymentsFactoringsFromHistory', {id: self.id, page: self.factoringsSelectedPage, rowsPerPage: self.factoringsRowsPerPage, sort: self.factoringsSort.sort,sortBy: self.factoringsSort.sortBy, search: self.factoringsSearch });
                factoringsFetch.then(response =>
                {
                    self.processRepaymentFactorings(response);
                }, ()=>
                {

                })
            },
            refreshRepaymentHistoryData()
            {
                let self = this;

                let historyFetch = self.$store.dispatch('repayments/getRepaymentsDetailHistory', {id: self.id, page: self.historySelectedPage, rowsPerPage: self.historyRowsPerPage, sort: self.historySort.sort,sortBy: self.historySort.sortBy });
                historyFetch.then(response =>
                {
                    self.processRepaymentHistory(response);
                }, ()=>
                {

                })
            },

            //process data
            processRepaymentHistory(obj)
            {
                let self = this;

                self.history = [];
                let rows = obj.Rows;

                for (let row of rows)
                {
                    let historyRowClient = {
                        Action: row.Action,
                        BankClaimId: row.BankClaimId,
                        Capital: row.Capital,
                        ClaimantName: row.ClaimantName,
                        Created: row.Created,
                        CreatedBy: row.CreatedBy,
                        DebtorName: row.DebtorName,
                        DebtorRegistryId: row.DebtorRegistryId,
                        ExpirationDate: row.ExpirationDate,
                        Id: row.Id,
                        Modified: row.Modified,
                        ModifiedBy: row.ModifiedBy,
                        Penalty: row.Penalty,
                        Processed: row.Processed,
                        Status: row.Status,
                        TransactionId: row.TransactionId,
                        Type: row.Type,
                    };
                    self.history.push(historyRowClient);
                }
                self.historyRowCount = obj.TotalRowCount;
            },
            processRepaymentFactorings (obj)
            {
                let self = this;

                self.factorings = [];
                let rows = obj.Rows;

                for (let row of rows)
                {
                    let factoringsRowClient = {
                        APR: row.APR,
                        Account: row.Account,
                        Capital: row.Capital,
                        Created: row.Created,
                        DebtorName: row.DebtorName,
                        DebtorRegistryId: row.DebtorRegistryId,
                        DueDate: row.DueDate,
                        FactoringDueDate: row.FactoringDueDate,
                        FeeAmount: row.FeeAmount,
                        Id: row.Id,
                        InitialTransferAmount: row.InitialTransferAmount,
                        LastPaymentDate: row.LastPaymentDate,
                        LeftToPay: row.LeftToPay,
                        Status: row.Status,
                    };
                    self.factorings.push(factoringsRowClient);
                }
                self.factoringsRowCount = obj.RowCount;
            },
            processRepaymentDetailData: function (obj) {
                let self = this;

                self.bankClaim = {
                    Id: obj.BankClaim.Id,
                    Account: obj.BankClaim.Account,
                    ClaimantRegistryId: obj.BankClaim.ClaimantRegistryId,
                    DueDate: obj.BankClaim.DueDate,
                    DebtorId: obj.BankClaim.DebtorId,
                    CancellationDate: obj.BankClaim.CancellationDate,
                    Identifier: obj.BankClaim.Identifier,
                    Amount: obj.BankClaim.Amount,
                    Reference: obj.BankClaim.Reference,
                    FinalDueDate: obj.BankClaim.FinalDueDate,
                    BillNumber: obj.BankClaim.BillNumber,
                    CustomerNumber: obj.BankClaim.CustomerNumber,
                    NoticeChargePrinting: obj.BankClaim.NoticeChargePrinting,
                    NoticeChargePaperless: obj.BankClaim.NoticeChargePaperless,
                    Status: self.$t(EnumIterator.processBankClaimStatus(obj.BankClaim.Status)),
                    TotalAmount: obj.BankClaim.TotalAmount,
                    DebtorName: obj.BankClaim.DebtorName,
                };

                self.repayment = {
                    Capital: obj.Capital,
                    Created: obj.Created,
                    CreatedBy: obj.CreatedBy,
                    DebtorId: obj.DebtorId,
                    DebtorName: obj.DebtorName,
                    ExpirationDate: obj.ExpirationDate,
                    Id: obj.Id,
                    Modified: obj.Modified,
                    ModifiedBy: obj.ModifiedBy,
                    Penalty: obj.Penalty,
                    Processed: obj.Processed,
                    RepaymentType: self.$t(EnumIterator.processRepaymentType(obj.RepaymentType)),
                    Status: self.$t(EnumIterator.processRepaymentStatus(obj.Status)),
                    TransactionId: obj.TransactionId
                }
            },
        },
    }
</script>

<style scoped>

</style>
